/** A word with its first letter capitalized, e.g. an essence type as a label: `fury` -> `Fury`. */
export function capitalize(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

/** A count with its noun, plural unless it is one: `countOf(2, 'skill point')` -> `2 skill points`. */
export function countOf(count: number, noun: string): string {
    return `${count} ${noun}${count === 1 ? '' : 's'}`;
}
